var SearchHistoryContainer = /** @class */ (function () {
    function SearchHistoryContainer(jobId, jobBoards, jobService, alertsAndNotificationsService) {
        this.jobId = jobId;
        this.jobBoards = jobBoards;
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    SearchHistoryContainer.prototype.$onInit = function () {
        this.searchHistory = [];
        this.busy = false;
        this.searchHistoryExistFlag = true;
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
    };
    SearchHistoryContainer.prototype.getNext = function () {
        var _this = this;
        if (this.busy)
            return;
        this.busy = true;
        this.currentPromise = this.jobService.getJobBoardsSearchHistory(this.jobId, this.searchHistoryQueryFilter.pageNum, this.searchHistoryQueryFilter.size, function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                if (data.length > 0) {
                    angular.forEach(data, function (search, key) {
                        search.jobBoards = angular.copy(_this._addJobBoardDetails(search.jobBoardId, search.daxtraParameters));
                        delete search.jobBoardId;
                        _this.searchHistory.push(search);
                    });
                    console.log('Parsed search history');
                    console.log(_this.searchHistory);
                    if (_this.searchHistoryQueryFilter.pageNum == 1) {
                        $('.panel-group').css({
                            "height": "500px",
                            "overflow-y": "scroll"
                        });
                    }
                    if (data.length < _this.searchHistoryQueryFilter.size) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.searchHistoryQueryFilter.pageNum++;
                    }
                }
                else {
                    _this.disableInfiniteScroll = true;
                }
                if (_this.searchHistory.length > 0) {
                    _this.searchHistoryExistFlag = true;
                }
                else {
                    _this.searchHistoryExistFlag = false;
                }
            }
            _this.busy = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SearchHistoryContainer.prototype._addJobBoardDetails = function (jobBoardIds, daxtraParameters) {
        var _this = this;
        var jobBoards = [];
        angular.forEach(jobBoardIds, function (jobBoardId, key) {
            var jobBoard = _this.jobBoards.find(function (jobBoard) {
                return jobBoard.id === jobBoardId;
            });
            //Parse daxtra params
            // jobBoard.allDaxtraParameters = angular.copy(_addDaxtraParametersToJobBoard(daxtraParameters, jobBoard.daxtraCode.toLowerCase()));
            // jobBoard.daxtraParameters = jobBoard.allDaxtraParameters.filter(function (param) {
            //     return param.value !== "";
            // });
            jobBoards.push(jobBoard);
        });
        return jobBoards;
    };
    return SearchHistoryContainer;
}());
export { SearchHistoryContainer };
//# sourceMappingURL=job-boards-search-history-infinite-scroll.js.map